module.exports = __webpack_public_path__ + "static/media/The-West-Subscription-footy-icon.a643365b.png";